import clsx from 'clsx';

export const YOUTUBE_URL = 'youtube.com';
const COLUMN = 'column';
const ROW = 'row';

export enum BlockTypes {
  ArticleCluster = 'articleCluster',
  DeepResearch = 'deepResearch',
  Experts = 'experts',
  Hero = 'hero',
  HorizontalRule = 'horizontalRule',
  HTML = 'html',
  Image = 'image',
  Newsletter = 'newsletter',
  RecommendedArticles = 'recommendedArticles',
  Section = 'section',
  SubscribeButton = 'subscribeButton',
  SubscribeMatrix = 'subscribeMatrix',
  TextContainer = 'textContainer',
  Video = 'video',
}

// Tuning Values from NLCMS Editor
export const CENTER = 'center';
export const alignmentValues = {
  center: 'text-center',
  left: 'text-left',
  right: 'text-right',
};

export const backgroundColorValues = {
  beige: 'bg-grayscale-beige',
  black: 'bg-primary-black',
  charcoal: 'bg-grayscale-charcoal',
  primary: 'bg-primary-magenta',
  secondary: 'bg-primary-pink',
  'pro-gold': 'bg-pro-gold',
  transparent: 'bg-transparent',
  white: 'bg-white',
};

export const colorValues = {
  beige: 'color-grayscale-beige',
  black: 'color-primary-black',
  charcoal: 'color-grayscale-charcoal',
  primary: 'color-primary-magenta',
  'pro-gold': 'color-pro-gold',
  secondary: 'color-primary-pink',
  white: 'color-white',
};

export const fontSizeValues = {
  small: 'text-body-md',
  normal: 'text-body-lg',
  large: 'text-headline-xxs',
  extraLarge: 'text-headline-xs',
};

export const fontFamilyValues = {
  meta: 'font-meta-normal',
  'meta-bold': 'font-meta-bold',
  'noto-serif': 'font-noto-serif',
  'suisse-intl': 'font-suisse-intl',
  'suisse-intl-mono': 'font-suisse-intl-mono',
  'suisse-neue': 'font-suisse-neue',
  'suisse-screen': 'font-suisse-screen',
  'suisse-works': 'font-suisse-works',
};

export const headingValues = {
  h1: 'text-headline-sm sm:text-headline-lg md:text-headline-xl',
  h2: 'text-headline-xs sm:text-headline-md lg:text-headline-lg',
  h3: 'text-headline-xxs sm:text-headline-xs',
  h4: 'text-headline-md',
  h5: 'text-headline-lg',
  h6: 'text-headline-xl',
};

export const marginValues = {
  small: 'mt-8',
  normal: 'mt-16',
  large: 'mt-24',
  extraLarge: 'mt-32',
};

export const paddingValues = {
  small: 'pt-8',
  normal: 'pt-16',
  large: 'pt-24',
  extraLarge: 'pt-32',
};

export const isFlex = (value: string) => [COLUMN, ROW].includes(value);

const gapValues = ''; // 'gap-y-48 sm:gap-y-64 md:gap-y-80 lg:gap-y-96';
export const gridValues = {
  row: clsx('flex flex-row', gapValues),
  column: clsx('flex flex-col', gapValues),
  grid: clsx('grid md:grid-cols-2', gapValues),
  'grid-3': clsx('grid grid-cols-2 md:grid-cols-3', gapValues),
  'grid-4': clsx('grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4', gapValues),
};

export const preloadValues = {
  auto: 'auto',
  metadata: 'metadata',
  none: 'none',
};

export const verticalAlignmentValues = {
  bottom: 'items-bottom',
  center: 'items-center',
  stretch: 'items-stretch',
  top: 'items-top',
};

export const widthValues = {
  auto: 'auto',
  '25': '25%',
  '50': '50%',
  '75': '75%',
  '100': '100%',
};
